import { InstrumentType } from '../model/instrumentsApi'
import { Id } from '../model/model'
import {
	useGetInstrumentData,
	usePollingAssessments,
	usePollingExamById,
	usePollingExams,
	usePollingInstrumentsInRoom,
	usePollingStages,
} from './usePolling'
import {
	useSocketAssessments,
	useSocketExamById,
	useSocketExams,
	useSocketExamsInPanelStores,
	useSocketGetWarnings,
	useSocketInstrument,
	useSocketInstrumentsInRoom,
	useSocketStore,
	useSocketStoreExams,
	useSocketUser,
} from './useSocket'

export const useSyncDataUser = (username: string) => {
	useSocketUser(username)
}

export const useSyncDataStore = () => {
	usePollingStages()
	useSocketStore()
}

export const useSyncDataAssessments = (isAppInsideEclips?: boolean) => {
	usePollingAssessments(isAppInsideEclips)
	useSocketAssessments(isAppInsideEclips)
}

export const useSyncDataExamById = (examId?: Id) => {
	usePollingExamById(examId)
	useSocketExamById(examId)
}

export const useSyncDataExams = (examIds: string[]) => {
	useSocketExams(examIds)
}

export const useSyncDataInstrument = (
	examId: Id,
	examLoaded: boolean,
	autoUpdate: boolean,
	instrumentType: InstrumentType,
) => {
	useGetInstrumentData(examId, examLoaded, autoUpdate, instrumentType)
	useSocketInstrument(examId, examLoaded, autoUpdate, instrumentType)
	useSocketGetWarnings(examId)
}

export const useSyncDataInstrumentsInRoom = (
	storeId: string,
	stageId: Id,
	roomId: Id,
) => {
	usePollingInstrumentsInRoom(storeId, stageId, roomId)
	useSocketInstrumentsInRoom(storeId, stageId, roomId)
}

export const useSyncWorklist = (storeId?: Id) => {
	useSocketStoreExams(storeId)
	useSocketExamsInPanelStores()
}

export const useSyncDataRefractionistExams = (
	storeId: Id,
	dateFrom: Date,
	mode: 'remote' | 'store',
) => {
	usePollingExams({
		dateFrom,
		storeId,
		mode,
		statusFrom: 'RefractionistStarted',
		statusTo: 'Uncompleted',
	})
	useSocketStoreExams(storeId)
}
